export const LOCATION_FETCH_REQUEST='location-fetch-request';
export const LOCATION_FETCH_SUCCESS='location-fetch-success';
export const LOCATION_FETCH_FAILURE='location-fetch-failure';